import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
	FreudButtonModule,
	FreudCheckboxModule,
	FreudDialogModule,
	FreudIconModule,
	FreudLoaderModule,
	FreudMessageService,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import {
	ZkAvatarModule,
	ZkButtonModule,
	ZkDialogModule,
	ZkIconModule,
	ZkInputModule,
	ZkTextModule,
	ZkTooltipModule,
} from '@zenklub/ng-ui';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AddressCardModule } from 'modules/address/components/address-card/address.card.module';
import { NgxMaskModule } from 'ngx-mask';
import { CalendarModule as PCalendarModule } from 'primeng/calendar';

import { ProfileCompletionModule } from '../account/profile-completion/profile-completion.module';
import { AlertBankLabelComponent } from './components/alert-bank-label/alert-bank-label.component';
import { AlertInfoBlockEditBankDataComponent } from './components/alert-info-status-block-edit-bank-data/alert-info-status-block-edit-bank-data.component';
import { AlertInfoComponent } from './components/alert-info-status/alert-info-status.component';
import { AlertLabelComponent } from './components/alert-label/alert-label.component';
import { AutoCompleteComponent } from './components/autocomplete/autocomplete.component';
import { BankDataComponent } from './components/bank-data/bank-data.component';
import { BillingAddressComponent } from './components/billing-address/billing-address.component';
import { BillingCardComponent } from './components/billing-card/billing-card.component';
import { BillingDataComponent } from './components/billing-data/billing-data.component';
import { BillingDocumentsComponent } from './components/billing-documents/billing-documents.component';
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { CompanyValidationComponent } from './components/companyValidation/companyValidation.component';
import { ZkCurrencyInputModule } from './components/currency-input/currency-input.module';
import { MyAccountMenuComponent } from './components/menu/menu.component';
import { OnlineSessions } from './components/online-sessions/online-sessions.component';
import { OnsiteSessions } from './components/onsite-sessions/onsite-sessions.component';
import { ProfessionalEducationComponent } from './components/professional-education/professional-education.component';
import { SessionsValuesModule } from './components/session-values/session-values.module';
import { MyAccountSignatureComponent } from './components/signature/signature.component';
import { MyAccountFinancialComponent } from './financial/financial.component';
import { MyAccountComponent } from './my-account.component';
import { MyAccountPersonalComponent } from './personal/personal.component';
import { MyAccountPlanAndSessionComponent } from './plan-and-session/plan-and-session.component';
import { MyAccountProfessionalComponent } from './professional/professional.component';

@NgModule({
	imports: [
		AutocompleteLibModule,
		CommonModule,
		FontAwesomeModule,
		FormsModule,
		FreudButtonModule,
		FreudDialogModule,
		FreudLoaderModule,
		FreudTooltipModule,
		FreudTypographyModule,
		NgxMaskModule,
		PCalendarModule,
		ProfileCompletionModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule,
		ZkAvatarModule,
		ZkButtonModule,
		ZkCurrencyInputModule,
		ZkDialogModule,
		ZkIconModule,
		ZkInputModule,
		ZkTextModule,
		ZkTooltipModule,
		SessionsValuesModule,
		AddressCardModule,
		FreudCheckboxModule,
		FreudIconModule,
	],
	declarations: [
		AlertBankLabelComponent,
		AlertInfoBlockEditBankDataComponent,
		AlertInfoComponent,
		AlertLabelComponent,
		AutoCompleteComponent,
		BankDataComponent,
		BillingAddressComponent,
		BillingCardComponent,
		BillingDataComponent,
		BillingDocumentsComponent,
		ChangePasswordFormComponent,
		CompanyValidationComponent,
		MyAccountComponent,
		MyAccountFinancialComponent,
		MyAccountMenuComponent,
		MyAccountPersonalComponent,
		MyAccountPlanAndSessionComponent,
		MyAccountProfessionalComponent,
		MyAccountSignatureComponent,
		OnlineSessions,
		OnsiteSessions,
		ProfessionalEducationComponent,
	],
	exports: [
		AlertInfoBlockEditBankDataComponent,
		AlertInfoComponent,
		AutoCompleteComponent,
		ChangePasswordFormComponent,
		MyAccountComponent,
		MyAccountFinancialComponent,
		MyAccountMenuComponent,
		MyAccountPersonalComponent,
		MyAccountPlanAndSessionComponent,
		MyAccountProfessionalComponent,
	],
	providers: [DatePipe, FreudMessageService],
})
export class MyAccountModule {}
